"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _RenderContent = _interopRequireDefault(require("../../../Internals/RenderContent"));

var _Placeholder = _interopRequireDefault(require("../../Row/Placeholder"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getColor = function getColor(color) {
  switch ((0, _typeof2["default"])(color)) {
    case "object":
      return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");

    default:
      return color || "transparent";
  }
};

var RowPreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RowPreview, _Component);

  var _super = _createSuper(RowPreview);

  function RowPreview() {
    (0, _classCallCheck2["default"])(this, RowPreview);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RowPreview, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props = this.props,
          parent = _this$props.content,
          _this$props$content = _this$props.content,
          content = _this$props$content.content,
          id = _this$props$content.id,
          internals = _this$props.internals;

      if (!(content && content.length) && internals.previewPlaceholders) {
        var renderPlaceholder = /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
          onClick: function onClick(e) {
            e.stopPropagation();
            internals.addChildToContent(id);
          }
        });

        return renderPlaceholder;
      }

      return content.map(function (child, idx) {
        if (!child) {
          return null;
        }

        var renderedChild = /*#__PURE__*/_react["default"].createElement(_RenderContent["default"], {
          key: idx,
          internals: internals,
          content: [child],
          parent: parent
        });

        return renderedChild;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          attrs = _this$props2.content.attrs,
          parent = _this$props2.parent;

      if (attrs.direction === "horizontal") {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.inlineDiv
        }, /*#__PURE__*/_react["default"].createElement("table", {
          className: classes.tableWrapper
        }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          className: classes.tableWrapperTd
        }, /*#__PURE__*/_react["default"].createElement("table", {
          className: classes.tableRow
        }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, this.renderChildren()))))))));
      } else if (parent && parent.attrs.direction === "horizontal") {
        return /*#__PURE__*/_react["default"].createElement("td", {
          className: classes.tdRow
        }, this.renderChildren());
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.inlineDiv
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: classes.tableWrapper
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: classes.tableWrapperTd
      }, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({
        className: classes.tableRow
      }, this.tableAttrs()), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: classes.tdColumn
      }, this.renderChildren())))))))));
    }
  }, {
    key: "tableAttrs",
    value: function tableAttrs() {
      var attrs = this.props.content.attrs;
      return {
        width: "100%",
        bgcolor: attrs.backgroundColor,
        border: "0",
        cellSpacing: "0",
        cellPadding: "0"
      };
    }
  }]);
  return RowPreview;
}(_react.Component);

function getUnpaddedWidth(_ref) {
  var paddingRight = _ref.paddingRight,
      paddingLeft = _ref.paddingLeft,
      calculatedWidth = _ref.calculatedWidth;
  return parseInt(calculatedWidth, 10) - (parseInt(paddingRight, 10) + parseInt(paddingRight, 10));
}

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    root: {// width: "100%",
      // margin: "0 auto",
      // overflowY: "hidden",
      // overflowX: "scroll",
    },
    inlineDiv: {
      width: function width(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs && "".concat(attrs.calculatedWidth, "px");
      },
      display: "inline-block",
      verticalAlign: "bottom",
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        height: "auto !important",
        display: "block !important"
      }
    },
    tableRow: {
      tableLayout: "fixed",
      width: function width(_ref3) {
        var attrs = _ref3.content.attrs;
        return attrs && "".concat(getUnpaddedWidth(attrs), "px");
      },
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        tableLayout: "auto !important"
      }
    },
    tdColumn: {
      textAlign: function textAlign(_ref4) {
        var attrs = _ref4.content.attrs;
        return attrs.alignment;
      },
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        display: "block !important",
        paddingRight: "0 !important",
        paddingLeft: "0 !important"
      }
    },
    tdRow: {
      wordWrap: "normal",
      verticalAlign: "top",
      width: function width(_ref5) {
        var attrs = _ref5.content.attrs,
            isEditor = _ref5.internals.isEditor;
        return !isEditor && attrs && attrs.width;
      },
      // width: ({ content: { attrs }, internals: { isEditor } }) =>
      //   !isEditor && attrs && (attrs.width || "") !== "" && "100%",
      minWidth: "100%",
      height: function height(_ref6) {
        var attrs = _ref6.content.attrs;
        return attrs && attrs.height;
      },
      minHeight: function minHeight(_ref7) {
        var attrs = _ref7.content.attrs;
        return attrs && attrs.height;
      },
      paddingTop: function paddingTop(_ref8) {
        var attrs = _ref8.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref9) {
        var attrs = _ref9.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref10) {
        var attrs = _ref10.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref11) {
        var attrs = _ref11.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      },
      alignItems: function alignItems(_ref12) {
        var attrs = _ref12.content.attrs;

        if (attrs && attrs.direction !== "vertical") {
          return "";
        }

        return attrs.alignment;
      },
      backgroundColor: function backgroundColor(_ref13) {
        var attrs = _ref13.content.attrs;
        return getColor(attrs.backgroundColor);
      },
      backgroundImage: function backgroundImage(_ref14) {
        var attrs = _ref14.content.attrs;
        return attrs.backgroundImage ? "url(".concat(attrs.backgroundImage, ")") : "";
      },
      backgroundSize: function backgroundSize(_ref15) {
        var attrs = _ref15.content.attrs;
        return attrs.backgroundSize;
      },
      backgroundRepeat: "no-repeat",
      border: function border(_ref16) {
        var attrs = _ref16.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(getColor(attrs.borderColor)) : null;
      },
      textAlign: function textAlign(_ref17) {
        var attrs = _ref17.content.attrs;
        return attrs.alignment || "left";
      },
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        display: "block !important",
        paddingRight: "0 !important",
        paddingLeft: "0 !important"
      }
    },
    tableWrapper: {
      height: function height(_ref18) {
        var attrs = _ref18.content.attrs;
        return attrs && attrs.height;
      },
      width: function width(_ref19) {
        var attrs = _ref19.content.attrs;
        return "".concat(attrs.computedWidth);
      },
      backgroundColor: function backgroundColor(_ref20) {
        var attrs = _ref20.content.attrs;
        return getColor(attrs.backgroundColor);
      },
      backgroundImage: function backgroundImage(_ref21) {
        var attrs = _ref21.content.attrs;
        return attrs.backgroundImage ? "url(".concat(attrs.backgroundImage, ")") : "";
      },
      backgroundSize: function backgroundSize(_ref22) {
        var attrs = _ref22.content.attrs;
        return attrs.backgroundSize;
      },
      backgroundRepeat: "no-repeat",
      border: function border(_ref23) {
        var attrs = _ref23.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(getColor(attrs.borderColor)) : null;
      },
      "@media only screen and (max-width: 675px)": {
        width: "100% !important",
        tableLayout: "auto !important"
      }
    },
    tableWrapperTd: {
      width: "100%",
      paddingTop: function paddingTop(_ref24) {
        var attrs = _ref24.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref25) {
        var attrs = _ref25.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref26) {
        var attrs = _ref26.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref27) {
        var attrs = _ref27.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      }
    },
    row: {
      justifyContent: function justifyContent(_ref28) {
        var attrs = _ref28.content.attrs;

        if (attrs && attrs.direction !== "horizontal") {
          return "";
        }

        if (!attrs.alignment || attrs.alignment === "left") {
          return "flex-start";
        } else if (attrs.alignment === "center") {
          return "space-around";
        } else if (attrs.alignment === "right") {
          return "space-around";
        }
      },
      alignItems: function alignItems(_ref29) {
        var attrs = _ref29.content.attrs;

        if (attrs && attrs.direction !== "vertical") {
          return "";
        }

        if (!attrs.alignment) {
          return "stretch";
        } else if (attrs.alignment === "left") {
          return "flex-start";
        } else if (attrs.alignment === "center") {
          return "center";
        } else if (attrs.alignment === "right") {
          return "flex-end";
        }
      },
      maxWidth: function maxWidth(_ref30) {
        var attrs = _ref30.content.attrs,
            isEditor = _ref30.internals.isEditor;
        return !isEditor && attrs && attrs.width;
      },
      width: function width(_ref31) {
        var attrs = _ref31.content.attrs,
            isEditor = _ref31.internals.isEditor;
        return !isEditor && attrs && (attrs.width || "") !== "" && "100%";
      },
      height: function height(_ref32) {
        var attrs = _ref32.content.attrs;
        return attrs && attrs.height;
      },
      minHeight: function minHeight(_ref33) {
        var attrs = _ref33.content.attrs;
        return attrs && attrs.height;
      },
      textAlign: function textAlign(_ref34) {
        var attrs = _ref34.content.attrs;
        return attrs.alignment || "left";
      },
      paddingTop: function paddingTop(_ref35) {
        var attrs = _ref35.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref36) {
        var attrs = _ref36.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref37) {
        var attrs = _ref37.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref38) {
        var attrs = _ref38.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      },
      backgroundColor: function backgroundColor(_ref39) {
        var attrs = _ref39.content.attrs;
        return getColor(attrs.backgroundColor);
      },
      backgroundImage: function backgroundImage(_ref40) {
        var attrs = _ref40.content.attrs;
        return attrs.backgroundImage ? "url(".concat(attrs.backgroundImage, ")") : "";
      },
      backgroundSize: function backgroundSize(_ref41) {
        var attrs = _ref41.content.attrs;
        return attrs.backgroundSize;
      },
      backgroundRepeat: "no-repeat",
      border: function border(_ref42) {
        var attrs = _ref42.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(getColor(attrs.borderColor)) : null;
      }
    },
    draggable: {
      alignItems: function alignItems(_ref43) {
        var attrs = _ref43.content.attrs;

        if (attrs && attrs.direction !== "vertical") {
          return "";
        }

        if (!attrs.alignment) {
          return "stretch";
        } else if (attrs.alignment === "left") {
          return "flex-start";
        } else if (attrs.alignment === "center") {
          return "center";
        } else if (attrs.alignment === "right") {
          return "flex-end";
        }
      },
      // border: `1px dashed ${theme.colors.secondary}`,
      // margin: "2px",
      "& > *": {
        width: "100%"
      }
    }
  };
})(RowPreview);

exports["default"] = _default;